module.exports = __webpack_public_path__ + "static/media/damperImg.e0f6d1f3.png";